import { createContext, useContext } from "react";

/**
 * Whether Shell's right rail (the Player AI side rail) is taking width from
 * `main` (PB-5436). The rail narrows `main` without changing the window, so a
 * frame that must react to it cannot use a media query.
 *
 * Only rail mode counts: popover and fullscreen render outside Shell and leave
 * `main` its full width. ModalShell and OverlaySurface provide `false` again,
 * because React context crosses portals and a dialog is sized by the window,
 * not by `main`. Outside a Shell the answer is `false`.
 */
export const ShellRightRailOccupiedContext = createContext(false);

export function useShellRightRailOccupied(): boolean {
  return useContext(ShellRightRailOccupiedContext);
}
